<!-- LoadingMessage.vue -->
<template>
  <div class="loading-overlay">
    <div class="loading-message">
      <p>Cargando...</p>
      <p>Espere unos segundos.</p>
      <i class="fas fa-spinner fa-spin"></i>
      <!-- Puedes agregar un spinner o algún otro indicador visual aquí -->
    </div>
  </div>
</template>
  
<script>
  export default {
    name: 'LoadingMessage',
  };
</script>

<style scoped>
/* Estilo para el fondo que cubre toda la pantalla */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fondo gris traslúcido */
  display: flex;
  justify-content: center; /* Centrar horizontalmente */
  align-items: center; /* Centrar verticalmente */
  z-index: 9999; /* Asegura que esté encima de otros elementos */
}

/* Estilo para el mensaje central */
.loading-message {
  background-color: white;
  padding: 20px 40px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

/* Spinner de Font Awesome */
.fa-spinner {
  margin-top: 10px;
  font-size: 24px;
  color: #3498db; /* Color del spinner */
}
</style>